/**
 * Wrap console.error so it logs locally during development but stays silent
 * in production builds. Use for catch blocks that don't need to alert the
 * user but are useful for debugging.
 */
export const logError = (...args) => {
    if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.error(...args);
    }
};
